import { z } from 'zod';

// Validation légère du paramètre d'URL `accessTokenKey` avant tout appel réseau : on ne connaît
// pas le format exact émis par le serveur. Les espaces en début/fin sont conservés, tandis que
// les espaces internes, les valeurs vides et les clés trop longues sont rejetés.
export const accessTokenKeySchema = z
  .string()
  .min(1, "Clé d'authentification manquante")
  .max(2048, "Clé d'authentification invalide")
  .refine(value => value.trim().length > 0, "Clé d'authentification manquante")
  .refine(value => !/\s/.test(value.trim()), "Clé d'authentification invalide");

export type AccessTokenKey = z.infer<typeof accessTokenKeySchema>;
